import debounce from 'lodash/debounce';

const getAddressData = async (url) => {
  try {
    const response = await fetch(url, {
      method: 'GET',
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error from Fetch:', error);
  }
};

export const getPhoneIsValid = debounce(
  async (
    value,
    number,
    country,
    projectConfig,
    setValidate,
    resolve,
    countryCallingCode,
    setIsPhoneValid,
    requestKey,
  ) => {
    if (!requestKey) {
      resolve(true);
      setValidate && setValidate(false);
      return true;
    }

    const local = country === 'AU' || country === 'NZ';
    setValidate && setValidate(true);
    const params = new URLSearchParams({
      Method: local
        ? 'DataTools.Verify.PhoneNumber.Equifax.VerifyPhoneNumberIsConnected'
        : 'DataTools.Verify.PhoneNumber.NumVerify.VerifyPhoneNumber',
      DefaultCountryCode: local ? countryCallingCode : country,
      PhoneNumber: number,
      DepartmentCode: 'saba',
      RequestKey: requestKey,
      OutputFormat: 'json',
    });

    return getAddressData(projectConfig.datatools.url + '?' + params).then(
      (data) => {
        const result = data?.DtResponse?.Result?.[0];
        if (
          result?.StatusCode && result?.StatusCode !== '1' ||
          result?.IsValid === 'True'
        ) {
          setIsPhoneValid && setIsPhoneValid(true);
          setValidate && setValidate(false);
          resolve(true);
          return true;
        } else {
          setIsPhoneValid && setIsPhoneValid(false);
          setValidate && setValidate(false);
          resolve(false);
          return false;
        }
      },
    );
  },
  600,
);
